module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var constants = require('Constants.js').default;

    ; __append("\r\n\r\n<div class=\"page-title\">\r\n    <div class=\"row\">\r\n        <div class=\"col col-sm-12\">\r\n            <h1>")
    ; __append(escapeFn( dashboardTitle ))
    ; __append("</h1>\r\n        </div>\r\n    </div>\r\n    <ol class=\"breadcrumb\">\r\n        ")
    ; 
        var count = breadcrumbs.length;
        var crumbCount = 0;
        _.forEach(breadcrumbs, function (crumb) {
                crumbCount++;
                if (crumbCount === count) {
                
    ; __append("\r\n                <li>")
    ; __append(escapeFn( crumb.name ))
    ; __append("</li>\r\n                ")
    ;  } else { 
    ; __append("\r\n                <li><a href=\"")
    ; __append(escapeFn( crumb.route ))
    ; __append("\" id=\"")
    ; __append(escapeFn( crumb.id ))
    ; __append("\">")
    ; __append(escapeFn( crumb.name ))
    ; __append("</a></li>\r\n                ")
    ; 
                }
        }); 
    ; __append("\r\n    </ol>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n       <H2>Filter</H2>\r\n    </div>\r\n </div>\r\n<div class=\"row\">\r\n    <div class=\"row\">\r\n    <div class=\"col-md-4 nopadding-l\">\r\n        <input type=\"text\" placeholder=\"Name\" name=\"groupName\" class=\"form-control\" value=\"")
    ; __append(escapeFn( this.model.get('search-groupName') ))
    ; __append("\">\r\n    </div>\r\n</div>\r\n</div>\r\n\r\n<div id=\"users-section\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            ")
    ;  if(totalRecords === '1') { 
    ; __append("\r\n            <h2>1 User-Group</h2>\r\n            ")
    ;  }else{ 
    ; __append("\r\n            <h2>")
    ; __append(escapeFn( totalRecords + ' User-Groups' ))
    ; __append("</h2>\r\n            ")
    ;  } 
    ; __append("\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <table id=\"propMainTable\"></table>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div id=\"footer-details\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-2\">\r\n            <button id='view-user' class=\"btn btn-default\" disabled>Details</button>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n        <h2>Settings Help</h2>\r\n        <div class=\"row nopadding-l\">\r\n            <div class=\"col-md-12 nopadding-l\"><a href=\"")
    ; __append(escapeFn(constants.HELP_QUICK_START ))
    ; __append("\" target=\"_blank\">Getting Started</a></div>\r\n        </div>\r\n        <div class=\"row nopadding-l\">\r\n            <div class=\"col-md-12 nopadding-l\"><a href=\"")
    ; __append(escapeFn(constants.HELP_ADMIN_PF ))
    ; __append("\" target=\"_blank\">Administering and Integrating PerfectApps</a></div>\r\n        </div>\r\n        <div class=\"row nopadding-l\">\r\n            <div class=\"col-md-12 nopadding-l\"><a href=\"")
    ; __append(escapeFn(constants.HELP_ADMIN_USERS ))
    ; __append("\" target=\"_blank\">Administering Users, User Groups and Positions</a></div>\r\n        </div>\r\n    </div>\r\n</div>\r\n")
  }
  return __output;

}